import styled from 'styled-components'


export const BtnWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  @media (max-width: 1199px) {
    flex-direction: column;
    align-items: flex-start;
  }
  @media (max-width: 767px) {
    align-items: center;
    margin-bottom: 10px;
  }
`
export const WrapperUploadImg = styled.div`
  
`
export const WrapperDivObt = styled.div`
  ${'' /* min-width: 200px; */}
  justify-content: center;
  align-items: center;
  ${'' /* margin:auto; */}
`

export const WrapperDiv = styled.div`
  ${'' /* min-width: 200px; */}
  justify-content: center;
  align-items: center;
  margin:auto;
`

export const WrapperUploadImgObt = styled.div`
  height: 100%;
  border: 2px dashed ;
  border-color: ${(props) => props.state == 'error' ? 'red' : '#B1C3C5'};
  border-radius: 5px;
  justify-content: center;
  align-items: center;
  margin:auto;
  display: ${(props) => props.displayN == '1' ? 'none' : 'table' };
  .wrapperDiv {
    min-width: 100px;
  }
  .error{
    margin: 0px;
  }
  .btn-click{
    border: none;
    @media (max-width: 767px) {
    min-width: 80%;
  }
  }

 
`

export const WrapperUploadImgObtEdition = styled.div`
  height: 100%;
  justify-content: center;
  align-items: center;
  margin:0px;
  color: #0066A5;  
  text-decoration: underline;
  display: ${(props) => props.displayN == '1' ? 'none' : 'table' };
  .wrapperDiv {
    min-width: 200px;
  }
  .error{
    margin: 0px;
  }
  .btn-click{
    border: none;
    @media (max-width: 767px) {
    min-width: 80%;
  }
  }
 
 
`

